import React from 'react';
import { Box, Typography } from '@mui/material';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';


type NoSessionOccurredModalProps = {
  isVisible: boolean;
  closeModal: () => void;
  goToCancelSession: () => void;
};

export const NoSessionOccurredModal: React.FC<NoSessionOccurredModalProps> = ({ isVisible, closeModal, goToCancelSession }) => {
  const l10n = useL10n();
  const isMobile = useIsMobile();

  return (
    <Modal
      open={isVisible}
      onClose={closeModal}
      title={l10n.sessions.noSessionOccurredModal.title}
    >
      <ModalContent>
        <Box>
          <Typography>{l10n.sessions.noSessionOccurredModal.description}</Typography>
        </Box>
      </ModalContent>
      <ModalActions>
        <Button
          name="cancel-no-session-occurred"
          variant="contained"
          color="secondary"
          onClick={goToCancelSession}
          fullWidth={isMobile}
        >
          {l10n.sessions.cancelNoSessionOccurred}
        </Button>
      </ModalActions>
    </Modal>
  );
};
